import React from 'react';
import { Eyebrow } from '../onyx/Text';
import { Panel } from '../onyx/Panel';
import { SectionHeader } from '../onyx/SectionHeader';
/**
 * Read-only recap of a participant's Persona ID verification.
 */
export const VerificationSection = ({ data, completedAt, loading = false }) => {
  if (loading || !data) {
    return (
      <Panel className="dashboard-section">
        <SectionHeader title="Identity Verification" description="Loading..." />
      </Panel>
    );
  }
  const street = data.address_street || data.address_street_1;
  const street2 = data.address_street_2;
  const country = data.address_country || data.address_country_code;
  return (
    <Panel className="dashboard-section">
      <SectionHeader
        title="Identity Verification"
        description={
          completedAt
            ? `Completed on ${new Date(completedAt).toLocaleDateString()}`
            : null
        }
      />
      <div className="onyx-detail-group">
        <Eyebrow>Personal Information</Eyebrow>
        <div className="onyx-detail-list">
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">Name</span>
            <span className="onyx-detail-value">
              {data.first_name} {data.last_name}
            </span>
          </div>
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">Date of Birth</span>
            <span className="onyx-detail-value">{formatDateNoTz(data.date_of_birth)}</span>
          </div>
        </div>
      </div>
      <div className="onyx-detail-group">
        <Eyebrow>Address</Eyebrow>
        <div className="onyx-detail-list">
          {street ? (
            <div className="onyx-detail-row onyx-detail-row--address">
              <span className="onyx-detail-label">Street</span>
              <span className="onyx-detail-value">
                {street}
                {street2 ? <><br />{street2}</> : null}
              </span>
            </div>
          ) : null}
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">City / State</span>
            <span className="onyx-detail-value">
              {data.address_city}, {data.address_state} {data.address_postal_code}
            </span>
          </div>
          {country ? (
            <div className="onyx-detail-row">
              <span className="onyx-detail-label">Country</span>
              <span className="onyx-detail-value">{country}</span>
            </div>
          ) : null}
        </div>
      </div>
      <div className="onyx-detail-group">
        <Eyebrow>Identification Document</Eyebrow>
        <div className="onyx-detail-list">
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">Type</span>
            <span className="onyx-detail-value">{data.id_type}</span>
          </div>
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">Number</span>
            <span className="onyx-detail-value">****{(data.id_number || '').slice(-4)}</span>
          </div>
          <div className="onyx-detail-row">
            <span className="onyx-detail-label">Expiration</span>
            <span className="onyx-detail-value">{formatDateNoTz(data.id_expiration_date)}</span>
          </div>
        </div>
      </div>
    </Panel>
  );
};

const formatDateNoTz = (value) => {
  if (!value) return 'N/A';
  const [y, m, d] = String(value).split('T')[0].split('-');
  return `${m}/${d}/${y}`;
};

export default VerificationSection;
